import isEmpty from "lodash/isEmpty";

import { GroupRegistrationText } from "@/constants/Schedule";
import { ExploreTestID } from "@/constants/TestID";
import type { AvatarCardProps } from "@/ui/core";
import { Text } from "@/ui/core";
import AvatarCard from "@/ui/core/AvatarCard";
import { VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface GroupClassSessionHostsProps {
  hosts?: AvatarCardProps[];
}

const baseTestID = joinTestIDs(ExploreTestID.GroupClassSessionCard, "hosts");

const GroupClassSessionHosts = ({ hosts }: GroupClassSessionHostsProps) => {
  if (isEmpty(hosts)) return null;

  return (
    <VStack gap={12}>
      <Text
        color={ColorToken.NeutralSecondary}
        testID={joinTestIDs(baseTestID, "label")}
        variant="caption"
      >
        {GroupRegistrationText.HostedByLabel}
      </Text>
      {hosts?.map((host) => (
        <AvatarCard
          key={host.userId}
          pronouns={host.pronouns}
          subtitle={host.subtitle}
          userId={host.userId}
          userName={host.userName}
          userType={host.userType}
        />
      ))}
    </VStack>
  );
};

export default GroupClassSessionHosts;
